/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IUser } from 'app/shared/model/user.model';
import { ITenant } from 'app/shared/model/tenant.model';
import { ITenantEmployee } from 'app/shared/model/tenant-employee.model';

export interface IUserRoles {
  id?: string;
  role?: string;
  timestampEntry?: number;
  microSec?: number;
  lastUpdated?: number;
  active?: boolean;
  cursor?: number;
  user?: IUser;
  tenant?: ITenant;
  subTenant?: ITenant;
  employee?: ITenantEmployee | null;
}

export const defaultValue: Readonly<IUserRoles> = {
  active: false,
};
